/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import Timeout from "await-timeout";
import DatePicker from "react-datepicker";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { fetchNotaDePedidoById, getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import { calcularFechaHabil } from "../../../pages/NotasDePedido/utils";
import MotivoNoAvanzaFormModal from "../MotivoNoAvanzaModal";
import { LabSelect } from "../../course/select";
import { CustomLabel } from "../../../ui/labels";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { ButtonPrimary } from "../../../ui/buttons";
import { getDerivaciones } from "../../../services/derivacionServices";

const FormMultiEditCandidato = ({ toggle, info, handleMultiEditCandidatos, derivacionId, notaDePedidoId, canCreateOV }) => {
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined);
  const estadosCandidato = categories && categories.estadoCandidatoNP ? categories.estadoCandidatoNP.type : [];
  const [estadoValue, setEstadoValue] = useState("");
  const fechaActual = moment().format("YYYY-MM-DD");
  const [fechaDeIngresoValue, setFechaDeIngresoValue] = useState(info.fechaDeIngreso || fechaActual);
  const [showFechaDeIngreso, setShowFechaDeIngreso] = useState(false);
  const [showMotivoNoAvanzaModal, setShowMotivoNoAvanzaModal] = useState(false);
  const [motivoValue, setMotivoValue] = useState(null);
  const [motivoOtroValue, setMotivoOtroValue] = useState("");
  const [difCobertura, setDifCobertura] = useState(null);
  const [loadingData, setLoadingData] = useState(false);

  const handleMotivoNoAvanza = (values) => {
    const { motivo, motivoOtro } = values;
    setMotivoValue(motivo);
    setMotivoOtroValue(motivoOtro);
  };

  useEffect(() => {
    if (estadoValue) {
      if (estadoValue.value === 5) {
        setShowFechaDeIngreso(true);
      } else {
        setShowFechaDeIngreso(false);
      }
      return true;
    }
    return true;
  }, [estadoValue]);

  useEffect(() => {
    const fetchData = async () => {
      if (derivacionId && notaDePedidoId) {
        setLoadingData(true);
        try {
          const notaResponse = await fetchNotaDePedidoById(notaDePedidoId);
          const notaData = notaResponse.result;

          const { vacantes } = notaData.rows[0];

          const derivacionesResponse = await getDerivaciones(notaDePedidoId);
          const derivacionesData = derivacionesResponse.result;

          const cubiertas = derivacionesData.rows.map((e) => e.cubiertas);
          const totalCubiertas = cubiertas.reduce((acumulador, valorActual) => acumulador + valorActual, 0);

          const coberturaState = vacantes - totalCubiertas;
          setDifCobertura(coberturaState);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        setLoadingData(false);
      }
    };

    fetchData();
  }, [derivacionId, notaDePedidoId]);

  const estadosOptions = estadosCandidato
    ? estadosCandidato.map((e) => {
        return { label: e.text, value: e.id };
      })
    : [];

  let estadosOptionsFiltered = estadosOptions;

  if (!derivacionId) {
    estadosOptionsFiltered = estadosOptions.filter((e) => e.value === 1 || e.value === 2 || e.value === 6 || e.value === 7);
  }

  if (derivacionId && notaDePedidoId && difCobertura === 0) {
    estadosOptionsFiltered = estadosOptions.filter((e) => e.value !== 5);
  }

  if (info && info.length > difCobertura && derivacionId && notaDePedidoId) {
    estadosOptionsFiltered = estadosOptions.filter((e) => e.value !== 5);
  }

  function getFunctionToFilter(filter, selected) {
    if (filter === "estado") {
      setEstadoValue(selected);
      if (selected.value === 6) setShowMotivoNoAvanzaModal(true);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDeIngresoValue(fechaFormateada);
  };
  const formik = useFormik({
    initialValues: {
      idsCandidatos: [],
      estado: "",
      notaDePedidoId,
      motivo: null,
      motivoOtro: null,
    },
    onSubmit: async (values) => {
      const dataToEdit = {
        ...values,
        idsCandidatos: info.map((e) => e.candidatoId),
        estado: estadoValue.value ? estadoValue.value : "",
        derivacionId: derivacionId || null,
        motivo: motivoValue || null,
        motivoOtro: motivoOtroValue || null,
      };
      if (derivacionId) {
        dataToEdit.derivacionId = derivacionId;
      }
      showFechaDeIngreso && (dataToEdit.fechaDeIngreso = fechaDeIngresoValue);

      try {
        if (estadoValue.value === 6 && !motivoValue) {
          toast.error("Debe seleccionar un motivo para el estado 'No avanza'");
          return;
        }
        handleMultiEditCandidatos(dataToEdit);
        await Timeout.set(1000);
        toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
  });

  return (
    <>
      <form className="w-100" onSubmit={formik.handleSubmit}>
        <div className="w-100 flex-column justify-content-center p-4 pt-0" style={{ display: "flex", justifyContent: "center" }}>
          <div className="w-100">
            <CustomLabel htmlFor="estado" className="pt-0 w-100">
              Estado
              <LabSelect
                id="estado"
                name="estado"
                className="w-100"
                onChange={handleReactSelectChange}
                value={estadoValue}
                placeholder="Seleccionar..."
                isLoading={isLoadingCategoies || loadingData}
                isDisabled={isLoadingCategoies || loadingData}
                options={estadosOptionsFiltered}
              />
            </CustomLabel>
          </div>

          {showMotivoNoAvanzaModal && (
            <MotivoNoAvanzaFormModal
              handleMotivoNoAvanza={handleMotivoNoAvanza}
              isOpen={showMotivoNoAvanzaModal}
              toggle={() => setShowMotivoNoAvanzaModal(!showMotivoNoAvanzaModal)}
              // info={relsCandidatosNPFinal}
            />
          )}
          {showFechaDeIngreso && (
            <div className="w-100">
              <StylesDatePicker className="my-2">
                <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                  Fecha de ingreso
                  <DatePicker
                    placeholder="fecha de ingreso"
                    className="date-input digits w-100"
                    dateFormat="AAAA-MM-dd"
                    onChange={handleDatesChange}
                    disabled={formik.isSubmitting}
                    value={fechaDeIngresoValue}
                    selected={fechaDeIngresoValue ? new Date(fechaDeIngresoValue).setDate(new Date(fechaDeIngresoValue).getDate() + 1) : null}
                    minDate={new Date(calcularFechaHabil(fechaActual, -1))}
                  />
                </CustomLabel>
              </StylesDatePicker>
            </div>
          )}

          {canCreateOV && estadoValue && estadoValue.value === 5 && (
            <div className="w-100 mt-3">
              <CustomLabel htmlFor="estado" className="p-2 w-100 mb-3" style={{ border: "1px solid red", borderRadius: "4px", fontWeight: "bold" }}>
                La Nota de Pedido pasará automáticamente a cubierta si se completan las vacantes. No se olvide de tener en estado Facturado la Orden de Venta primero.
              </CustomLabel>
            </div>
          )}
        </div>

        <div className=" mt-3 mb-0 d-flex justify-content-end align-items-end">
          <Button color="btn-secondary mr-2" style={{ height: "40px" }} onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary disabled={formik.isSubmitting} fontSize="14px" type="submit">
            Editar candidatos
          </ButtonPrimary>
        </div>
      </form>
    </>
  );
};

export default FormMultiEditCandidato;
